/**
 * Needed quiz — shared engine. Register a variant via NeededQuizCore.register().
 */
(function () {
const NeededQuizVariant = {
  recommendedPlan() { throw new Error('[needed-quiz] Variant not registered'); },
  getPlanBenefits() { return []; },
  appendResultMerchandising() {},
};

const QUIZ_ROOT = document.getElementById('needed-quiz-root');
if (!QUIZ_ROOT) console.error('[needed-quiz] Missing #needed-quiz-root');
// ============================================================
//   STATE
// ============================================================
const state = {
  step: 'intro',
  history: [],
  answers: {
    lifestage: null,        // egg_freezing | ttc | pregnant | postpartum
    stageDetail: null,
    dueDate: null,
    breastfeeding: null,
    currentPrenatal: null,
    symptoms: [],
    dhaIntake: null,
    ironStatus: null,
    formatPreference: null,
  },
};

// step → (progress %, label)
const STEPS = [
  'intro',
  'q1', 'i1',
  'q2', 'i2',
  'q3', 'i3',
  'q4', 'i4',
  'q5', 'i5',
  'q6', 'i6',
  'q7', 'i7',
  'result',
];
function progressFor(step) {
  function fmt(pct) { return Math.round(pct) + '%'; }
  if (step === 'intro') return { pct: 0, label: fmt(0) };
  if (step === 'result') return { pct: 100, label: fmt(100) };
  const m = step.match(/^q(\d)$/);
  if (m) {
    const n = parseInt(m[1], 10);
    const pct = ((n - 1) / 7) * 100;
    return { pct, label: fmt(pct) };
  }
  const im = step.match(/^i(\d)$/);
  if (im) {
    const n = parseInt(im[1], 10);
    const pct = (n / 7) * 100;
    return { pct, label: fmt(pct) };
  }
  if (step === 'i7')  return { pct: 100, label: fmt(100) };
  return { pct: 0, label: fmt(0) };
}

function updateProgress() {
  const { pct, label } = progressFor(state.step);
  document.getElementById('progress-fill').style.width = pct + '%';
  document.getElementById('progress-label').textContent = label;
}

// ============================================================
//   NAV
// ============================================================
function go(next) {
  state.history.push(state.step);
  state.step = next;
  render();
  const _s = document.querySelector('.desktop-shell .stage');
  if (_s) _s.scrollTop = 0; else window.scrollTo(0, 0);
}
function back() {
  if (state.history.length === 0) return;
  state.step = state.history.pop();
  render();
  const _s = document.querySelector('.desktop-shell .stage');
  if (_s) _s.scrollTop = 0; else window.scrollTo(0, 0);
}

// What comes after q2 depends on lifestage but flow is linear from there
function nextAfter(step) {
  const order = ['intro','q1','i1','q2','i2','q3','i3','q4','i4','q5','i5','q6','i6','q7','i7','result'];
  const idx = order.indexOf(step);
  return order[idx + 1];
}

// ============================================================
//   DEPLETION SCORE
// ============================================================
function depletionScore() {
  const a = state.answers;
  let s = 0;
  if (a.lifestage === 'pregnant' || a.lifestage === 'postpartum') s += 2;
  else if (a.lifestage === 'ttc') s += 1;
  else if (a.lifestage === 'egg_freezing') s += 1;

  // Q2 score
  const heavyDetails = ['ttc_12plus', 'pregnant_t3', 'postpartum_0_3', 'egg_freezing_0_3'];
  if (heavyDetails.includes(a.stageDetail)) s += 2;
  else if (a.stageDetail) s += 1;

  // Q3
  if (['leading_retail', 'whole_food_gummy', 'none'].includes(a.currentPrenatal)) s += 3;
  else if (a.currentPrenatal === 'rx') s += 1;

  // Q4 — symptoms
  if (a.symptoms.length && !a.symptoms.includes('feel_okay')) {
    s += Math.min(a.symptoms.filter(x => x !== 'feel_okay').length, 6);
  }

  // Q5 — DHA
  if (a.dhaIntake === 'rarely_never' || a.dhaIntake === 'avoid_fish') s += 2;
  else if (a.dhaIntake === 'few_times_month') s += 1;

  // Q6 — Iron
  if (a.ironStatus === 'low_borderline' || a.ironStatus === 'untested_at_risk') s += 2;
  else if (a.ironStatus === 'never_tested') s += 1;

  return s;
}

// ============================================================
//   PLAN ROUTING
// ============================================================
// Plan hero images — resolved at runtime from inlined bundle resources
const IMG = {
  multi_capsule:    'https://cdn.shopify.com/s/files/1/0195/3293/9328/files/Prenatal_Multi_Ess_Citrus_S_JAR_HN_Tr_1.png?v=1770922569',
  multi_powder:     'https://cdn.shopify.com/s/files/1/0195/3293/9328/files/PDP_Prenatal_Multi_Powder_Gallery_01.png?v=1771621335',
  iron_dha:         window.__resources.imgIronDha,
  iron_dha_powder:  window.__resources.imgIronDhaPowder,
  iron_dha_pro:     window.__resources.imgIronDhaPro,
  egg_freezing:     window.__resources.imgEggFreezing,
  egg_freezing_p:   window.__resources.imgEggFreezingPowder,
  ttc:              window.__resources.imgTtc,
  ttc_powder:       window.__resources.imgTtcPowder,
  postnatal:        window.__resources.imgPostnatal,
  postnatal_powder: window.__resources.imgPostnatalPowder,
  mens_fertility:   window.__resources.imgMensFertility,
};

// Partner plan — shown alongside the primary recommendation when applicable
function partnerPlan() {
  const a = state.answers;
  if (a.lifestage === 'ttc' && (a.stageDetail === 'ttc_6_12' || a.stageDetail === 'ttc_12plus')) {
    return {
      id: 'mens_fertility',
      tag: 'For your partner',
      name: "The Men's Fertility Support Plan",
      price: '$178',
      cadence: '/ month',
      components: ["Men's Multi", "Men's Omega-3", 'Sperm Support+', 'CoQ10'],
      proofs: [
        {
          heading: 'Sperm health is half the equation.',
          body: 'After 6+ months of trying, the data shows male factors are involved roughly half the time. This is the moment to bring your partner in.',
        },
        {
          heading: 'Sperm cells take ~74 days to mature.',
          body: 'What he eats today is what shows up at conception 2–3 months from now. The window starts now.',
        },
        {
          heading: 'Four products, one job: optimize fatherhood-readiness.',
          body: "Men's Multi covers his foundational nutrients. Men's Omega-3 supports sperm membrane integrity and motility. Sperm Support+ adds NAC, Shilajit, and clinically studied pre/probiotics. CoQ10 (Ubiquinol) supports the mitochondrial energy that sperm cells run on — and CoQ10 levels naturally decline starting around age 30.",
        },
      ],
      url: 'https://thisisneeded.com/products/mens-fertility-support-plan',
      image: IMG.mens_fertility,
    };
  }
  return null;
}

function proofPoints() {
  const a = state.answers;
  const points = [];

  // ---- Symptoms: "Common doesn't mean normal" ----
  const symptomNutrients = {
    fatigue:   ['iron', 'B12', 'B6'],
    nausea:    ['B6'],
    brain_fog: ['choline', 'methylated folate', 'DHA'],
    mood:      ['choline', 'DHA', 'B-complex'],
    sleep:     ['magnesium', 'vitamin D'],
    hair_skin: ['zinc', 'biotin', 'selenium'],
  };
  const realSymptoms = a.symptoms.filter(s => s !== 'feel_okay');
  if (realSymptoms.length > 0) {
    const allNutrients = realSymptoms.flatMap(s => symptomNutrients[s] || []);
    const uniqNutrients = Array.from(new Set(allNutrients));
    let nutrientList;
    if (uniqNutrients.length === 1) {
      nutrientList = uniqNutrients[0];
    } else if (uniqNutrients.length === 2) {
      nutrientList = uniqNutrients.join(' and ');
    } else {
      nutrientList = uniqNutrients.slice(0, -1).join(', ') + ', and ' + uniqNutrients[uniqNutrients.length - 1];
    }
    points.push({
      heading: "Common doesn't mean normal.",
      body: `As women, these symptoms get normalized — but just because they're common doesn't mean they're normal. They're common signs of nutritional depletion. Yours are pointing at ${nutrientList}.`,
    });
  } else if (a.symptoms.includes('feel_okay')) {
    const lsTail = {
      egg_freezing: 'And every nutrient you load during egg prep becomes the foundation of the eggs you\'ll freeze.',
      ttc:          'And while trying to conceive, your nutrient stores at conception become your baby\'s foundation.',
      pregnant:     'And during pregnancy, your body\'s demands climb every single trimester, whether you feel them or not.',
      postpartum:   'And in the postpartum window, depletion shows up later — long after the moments where it\'s easiest to fix.',
    };
    points.push({
      heading: 'Feeling fine isn\'t the same as being optimized.',
      body: 'Nutrient depletion can be silent and subtle — many markers are subclinical until they\'re not. ' + (lsTail[a.lifestage] || lsTail.ttc),
    });
  }

  const ironCovered = a.ironStatus === 'in_range';
  const dhaCovered  = a.dhaIntake === 'twice_weekly';

  // DHA proof — lifestage-aware
  if (dhaCovered) {
    points.push({
      heading: 'You\'re already covering your DHA from food.',
      body: '2+ servings of fatty fish a week is exactly what most clinicians recommend. We\'re not going to upsell you something you already have — but if your fish intake drops, Omega-3 is one click away.'
    });
  } else if (a.dhaIntake === 'rarely_never' || a.dhaIntake === 'avoid_fish') {
    const lowDhaCopy = {
      egg_freezing: {
        heading: 'You\'re likely short on the DHA your eggs need.',
        body: 'DHA supports egg cell membrane integrity and the future brain that will form from those eggs — and 95% of women don\'t hit their omega-3 target. Your Plan includes Needed Omega-3, sourced sustainably and third-party tested.',
      },
      ttc: {
        heading: 'You\'re likely 70%+ short on the DHA your future pregnancy needs.',
        body: 'DHA needs to be loaded 90+ days before conception — and 95% of women don\'t hit it. Your Plan includes Needed Omega-3, sourced sustainably and third-party tested.',
      },
      pregnant: {
        heading: 'You\'re likely 70%+ short on pregnancy\'s DHA needs.',
        body: 'Pregnancy needs 200–300 mg of DHA daily — and 95% of mothers don\'t hit it. Your Plan includes Needed Omega-3, sourced sustainably and third-party tested.',
      },
      postpartum: {
        heading: 'You\'re likely short on the DHA breastfeeding (and your recovery) needs.',
        body: 'Your DHA becomes your baby\'s DHA through breastmilk — and it supports your mood and brain too. 95% of mothers don\'t hit their omega-3 target. Your Plan includes Needed Omega-3, sourced sustainably and third-party tested.',
      },
    };
    points.push(lowDhaCopy[a.lifestage] || lowDhaCopy.ttc);
  } else if (a.dhaIntake === 'few_times_month' || a.dhaIntake === 'about_weekly') {
    const moderateDhaCopy = {
      egg_freezing: {
        heading: 'Even weekly fish leaves a DHA gap.',
        body: 'Egg quality and a future pregnancy both need ~200–300 mg of DHA daily — that\'s salmon every single day. Your Plan covers the gap.',
      },
      ttc: {
        heading: 'Even weekly fish leaves a DHA gap.',
        body: 'Your future pregnancy will need 200–300 mg of DHA daily — that\'s salmon every single day. Better to enter that window with stores already loaded.',
      },
      pregnant: {
        heading: 'Even weekly fish leaves a DHA gap.',
        body: 'Pregnancy needs 200–300 mg of DHA daily — that\'s salmon every single day. Your Plan covers the gap.',
      },
      postpartum: {
        heading: 'Even weekly fish leaves a DHA gap.',
        body: 'Breastfeeding pulls DHA from you to your baby — 200–300 mg/day is the working target. Your Plan covers what fish doesn\'t.',
      },
    };
    points.push(moderateDhaCopy[a.lifestage] || moderateDhaCopy.ttc);
  }

  // Iron proof
  if (ironCovered) {
    points.push({
      heading: 'Your iron is in range — no need to over-supplement.',
      body: 'Iron above what your body needs can generate oxidative stress. We only recommend it when it\'s actually warranted.'
    });
  } else if (a.lifestage === 'pregnant') {
    if (a.ironStatus === 'low_borderline') {
      points.push({
        heading: 'You\'re already flagged low — and pregnancy doubles your iron need.',
        body: 'Needed Iron is glycinate-bound for gentler digestion and dosed separately from your Multi for better absorption.'
      });
    } else if (a.ironStatus === 'untested_at_risk' || a.ironStatus === 'never_tested') {
      points.push({
        heading: 'Iron is the nutrient most pregnancies run short on.',
        body: 'Up to half of pregnant women develop iron-deficiency anemia. Needed Iron is separate by design — for personalized dosing and gentler digestion.'
      });
    }
  }

  // Always close with the headline 8x stat
  points.push({
    heading: 'Needed delivers 8× more nutrition than the leading prenatals.',
    body: '4× more vitamin D · 20× more B6 · 12× more choline · 31× more B12. All in 22 bioavailable nutrients, vetted by clinical experts.'
  });

  // Trim to 3 max
  return points.slice(0, 2);
}

// ============================================================
//   RENDERERS
// ============================================================
function el(tag, attrs = {}, ...children) {
  const e = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (k === 'class') e.className = v;
    else if (k === 'html') e.innerHTML = v;
    else if (k.startsWith('on')) e.addEventListener(k.slice(2).toLowerCase(), v);
    else e.setAttribute(k, v);
  }
  for (const c of children) {
    if (c == null) continue;
    e.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
  }
  return e;
}

function quizAtc(className, text, url) {
  return window.NeededQuizCart.createButton({ className, text, url });
}

function clearStage() {
  const stage = document.getElementById('stage');
  stage.innerHTML = '';
  return stage;
}

function backRow(extra) {
  const row = el('div', { class: 'btn-row' });
  if (state.history.length > 0) {
    row.appendChild(el('button', { class: 'back-link', onclick: back }, '← Back'));
  }
  if (extra) row.appendChild(extra);
  return row;
}

function singleSelect(field, options, onPick) {
  const wrap = el('div', { class: 'options' });
  options.forEach(opt => {
    const selected = state.answers[field] === opt.value;
    const item = el('button', {
      class: 'option' + (selected ? ' selected' : ''),
      onclick: () => {
        state.answers[field] = opt.value;
        if (opt.followUp) opt.followUp();
        if (onPick) { onPick(); }
        else { render(); setTimeout(() => go(nextAfter(state.step)), 280); }
      }
    });
    item.appendChild(el('span', { class: 'check' }));
    item.appendChild(el('span', {}, opt.label));
    wrap.appendChild(item);
  });
  return wrap;
}

function multiSelect(field, options) {
  const wrap = el('div', { class: 'options' });
  options.forEach(opt => {
    const selected = state.answers[field].includes(opt.value);
    const item = el('button', {
      class: 'option multi' + (selected ? ' selected' : ''),
      onclick: () => {
        const arr = state.answers[field];
        // "Feel okay" is exclusive
        if (opt.value === 'feel_okay') {
          state.answers[field] = arr.includes('feel_okay') ? [] : ['feel_okay'];
        } else {
          state.answers[field] = arr.includes(opt.value)
            ? arr.filter(v => v !== opt.value)
            : [...arr.filter(v => v !== 'feel_okay'), opt.value];
        }
        render();
      }
    });
    item.appendChild(el('span', { class: 'check' }));
    item.appendChild(el('span', {}, opt.label));
    wrap.appendChild(item);
  });
  return wrap;
}

// ============================================================
//   SCREENS
// ============================================================
function screenIntro() {
  const stage = clearStage();
  const card = el('div', { class: 'card intro' });

  card.appendChild(el('h1', {}, 'Are you nutritionally depleted?'));
  card.appendChild(el('p', { class: 'intro-subhead' },
    'Find out if you\'re in the 95% of women who are.'
  ));
  card.appendChild(el('p', { class: 'lead' },
    'Answer 7 questions to see where your gaps are — and get a personalized plan to close them, plus we\'ll give you 20% off.'
  ));

  // CRO stats strip
  const meta = el('div', { class: 'intro-stats' });
  const stats = [
    { num: '1M+',  label: 'Prenatals Sold' },
    { num: '500k', label: 'Women Trust Needed' },
    { num: '15k+', label: 'Practitioners Recommend' },
    { num: '8×',   label: 'More Nutrition' },
  ];
  stats.forEach(s => {
    const item = el('div', { class: 'intro-stat' });
    item.appendChild(el('div', { class: 'intro-stat-num' }, s.num));
    item.appendChild(el('div', { class: 'intro-stat-label' }, s.label));
    meta.appendChild(item);
  });
  card.appendChild(meta);

  const btn = el('button', { class: 'btn lg', onclick: () => go('q1') }, 'Find Your Plan →');
  card.appendChild(el('div', { class: 'btn-row' }, btn));

  // disclaimer moved to footer

  stage.appendChild(card);
}

function screenQ1() {
  const stage = clearStage();
  const card = el('div', { class: 'card' });
  card.appendChild(el('div', { class: 'eyebrow' }, 'QUESTION 1 OF 7'));
  card.appendChild(el('h1', {}, 'Where are you in your motherhood journey?'));
  card.appendChild(el('p', { class: 'helper' }, 'There\'s no wrong answer — your stage shapes everything.'));
  card.appendChild(singleSelect('lifestage', [
    { value: 'egg_freezing', label: 'Preparing for egg freezing or IVF' },
    { value: 'ttc',          label: 'Trying to conceive' },
    { value: 'pregnant',     label: 'Pregnant' },
    { value: 'postpartum',   label: 'Postpartum or breastfeeding' },
  ]));
  card.appendChild(backRow());
  stage.appendChild(card);
}

function productForInterstitial(stepKey) {
  const a = state.answers;
  const ls = a.lifestage;
  const map = {
    i1: { name: 'Prenatal Multi', tag: 'Nutritional Foundation', tie: '22 nutrients in just 3 capsules, delivering 12x more nutrition than leading prenatals, at clinically studied dosages of key nutrients that make all the difference.*', img: window.__resources.imgMultiCapsule },
    i2: ls === 'postpartum'
      ? { name: 'Prenatal Multivitamin', tag: 'For postpartum', tie: "We recommend our Prenatal Multivitamin — formulated to support women's needs pre, during, and post-pregnancy.", img: window.__resources.imgMultiCapsule }
      : (ls === 'egg_freezing' && state.answers.stageDetail === 'egg_freezing_post')
      ? { name: 'Prenatal Multi', tag: 'For transfer prep', tie: 'Folate, choline, and vitamin D support uterine health and healthy cell division — the foundation of a successful transfer.', img: window.__resources.imgMultiCapsule }
      : { name: 'Prenatal Multi', tag: 'For this window', tie: 'The Prenatal Multi is your nutritional foundation. Egg Quality Support + CoQ10 work alongside it to specifically support egg development during this window.', img: window.__resources.imgMultiCapsule },
    i3: { name: 'Prenatal Multi', tag: 'Clinical-grade', tie: '12× more nutrition than the leading prenatal. Because meeting the minimum was never the goal.', img: window.__resources.imgMultiCapsule },
    i4: (a.symptoms && a.symptoms.includes && a.symptoms.includes('feel_okay'))
      ? { name: 'Prenatal Multi', tag: 'Foundational', tie: "Subclinical depletion is real — and common precisely because standard prenatals underdose.", img: window.__resources.imgMultiCapsule }
      : { name: 'Prenatal Multi', tag: 'For your symptoms', tie: "If you're already on a prenatal and still feeling this — the formula may be the gap.", img: window.__resources.imgMultiCapsule },
    i5: { name: 'Omega-3', tag: 'DHA + EPA', tie: "Delivers 1,000 mg of DHA+EPA per serving — 2× more than most prenatal omega-3s", img: 'https://cdn.shopify.com/s/files/1/0195/3293/9328/files/PDP_Omega3_Gallery_01.png?v=1772035571' },
    i6: { name: 'Iron', tag: 'Glycinate-bound', tie: 'Iron and multivitamins absorb better separately. Needed separates them by design — personalized dosing, gentler digestion.', img: 'https://cdn.shopify.com/s/files/1/0195/3293/9328/files/Iron_XXS_ALT_Transparent_03a93a9b-f8b6-4977-83e3-152335093968.png?v=1771539610' },
  };
  return map[stepKey] || null;
}

function screenInterstitial({ label, stat, body, sourceNote, bridge, tail, comparison }) {
  const stage = clearStage();
  const card = el('div', { class: 'card interstitial' });
  const statEl = el('div', { class: 'stat', html: stat });
  card.appendChild(statEl);
  card.appendChild(el('div', { class: 'divider' }));
  if (Array.isArray(body)) {
    const ul = el('ul', { class: 'body-bullets' });
    body.forEach(b => { const li = el('li', {}, b); ul.appendChild(li); });
    card.appendChild(ul);
  } else {
    card.appendChild(el('p', { class: 'body' }, body));
  }
  if (bridge) {
    card.appendChild(el('p', { class: 'bridge' }, bridge));
    if (tail) card.appendChild(el('p', { class: 'body', style: 'margin-bottom: 32px;' }, tail));
  }
  if (sourceNote) {
    card.appendChild(el('p', { class: 'helper', style: 'margin-bottom: 0;' }, sourceNote));
  }
  // Comparison table (Needed vs. Others)
  if (comparison && comparison.length) {
    const tbl = el('div', { class: 'comp-table' });
    const hdr = el('div', { class: 'comp-row comp-header' });
    hdr.appendChild(el('div', { class: 'comp-label' }));
    const neededCol = el('div', { class: 'comp-col needed-col' });
    const brandLogo = document.querySelector('.brand-logo');
    if (brandLogo) {
      const logoImg = el('img', { src: brandLogo.src, alt: 'Needed', class: 'comp-needed-logo' });
      neededCol.appendChild(logoImg);
    } else {
      neededCol.appendChild(document.createTextNode('Needed'));
    }
    hdr.appendChild(neededCol);
    hdr.appendChild(el('div', { class: 'comp-col others-col comp-others-header' }, 'Leading Prenatals'));
    tbl.appendChild(hdr);
    comparison.forEach(row => {
      const r = el('div', { class: 'comp-row' });
      r.appendChild(el('div', { class: 'comp-label' }, row.label));
      const nCell = el('div', { class: 'comp-col needed-col' });
      if (row.needed) nCell.appendChild(el('span', { class: 'check-circle' }, '✓'));
      r.appendChild(nCell);
      const oCell = el('div', { class: 'comp-col others-col' });
      oCell.appendChild(document.createTextNode(row.others ? '✓' : '×'));
      r.appendChild(oCell);
      tbl.appendChild(r);
    });
    card.appendChild(tbl);
  }
  const prod = comparison && comparison.length ? null : productForInterstitial(state.step);
  if (prod) {
    const tile = el('div', { class: 'i-product' });
    const imgWrap = el('div', { class: 'i-prod-img' });
    if (prod.img) { const pi = el('img', { src: prod.img, alt: prod.name, loading: 'eager' }); pi.onerror = () => pi.remove(); imgWrap.appendChild(pi); }
    tile.appendChild(imgWrap);
    const meta = el('div', { class: 'i-prod-meta' });
    meta.appendChild(el('div', { class: 'i-prod-tag' }, prod.tag));
    meta.appendChild(el('div', { class: 'i-prod-name' }, prod.name));
    meta.appendChild(el('div', { class: 'i-prod-tie' }, prod.tie));
    tile.appendChild(meta);
    card.appendChild(tile);
  }
  const btn = el('button', { class: 'btn lg', onclick: () => go(nextAfter(state.step)) }, 'Continue →');
  card.appendChild(el('div', { class: 'btn-row' },
    state.history.length > 0 ? el('button', { class: 'back-link', onclick: back }, '← Back') : null,
    btn
  ));
  stage.appendChild(card);
}

function screenWhyPrenatal() {
  const ls = state.answers.lifestage;
  const reasons = {
    egg_freezing: {
      stat: 'Your <em>eggs are forming</em> the future.',
      body: 'Egg cell maturation takes 3–4 months. The nutrients you\'re consuming during that window become the building blocks of every egg you freeze. Folate, choline, antioxidants, and CoQ10 aren\'t optional during prep — they\'re essential.',
    },
    ttc: {
      stat: 'Your nutrient stores <em>become</em> your baby\'s foundation.',
      body: 'Methylated folate alone reduces neural tube defects by up to 70% — and it needs to be optimal at conception, not after a positive test. Choline, DHA, and the B-complex need to be loaded 90+ days before you conceive. Diet alone almost never gets you there.',
    },
    pregnant: {
      stat: 'Your body is <em>building a human</em> from scratch.',
      body: 'Iron needs nearly double. Folate, choline, and DHA needs climb every trimester. Even the most balanced diet can\'t keep up with what pregnancy demands — that\'s why prenatals exist. The question isn\'t whether to take one. It\'s which one.',
    },
    postpartum: {
      stat: 'Pregnancy can drain your stores by <em>30–40%.</em>',
      body: 'Postpartum depletion is real, underdiscussed, and a major reason so many mothers feel exhausted, foggy, and depleted long after birth. Whether you\'re breastfeeding or not, your body is recovering — a high-quality prenatal is replenishment, not a relic of pregnancy.',
    },
  };
  const r = reasons[ls] || reasons.ttc;
  return screenInterstitial({
    label: 'WHY A PRENATAL · 3 OF 6',
    stat: r.stat,
    body: r.body,
    bridge: 'But not all prenatals are created equal.',
    tail: '95% of women on a standard prenatal are still nutritionally depleted. Needed delivers 12× more nutrition than the leading prenatals — including 4× more vitamin D, 20× more B6, 12× more choline, and 31× more B12.',
  });
}

function screenAlreadyOnNeeded() {
  return screenInterstitial({
    label: 'WELL DONE · 3 OF 6',
    stat: 'You\'re already <em>ahead</em> of 95% of women.',
    body: 'Congratulations — you\'re already on Needed. While most women on a standard prenatal are still nutritionally depleted, you\'ve already chosen the prenatal clinically formulated to defeat that. From here, we\'re fine-tuning your stack, not catching it up.',
  });
}

function screenSilentDepletion() {
  const ls = state.answers.lifestage;
  const lifestageBlurb = {
    egg_freezing: "for someone preparing eggs for retrieval, prioritizing optimal nutrition isn't optional — every nutrient you load now becomes the building blocks of the eggs you'll freeze.",
    ttc:          "for someone trying to conceive, prioritizing optimal nutrition isn't optional — your nutrient stores at conception become your baby's foundation, and folate, choline, and DHA need to be optimal before a positive test, not after.",
    pregnant:     "for someone growing a baby, prioritizing optimal nutrition isn't optional — your body's demands climb every single trimester, whether you feel them or not. Iron needs nearly double; folate, choline, and DHA needs climb with them.",
    postpartum:   "for someone in the postpartum window, prioritizing optimal nutrition isn't optional — pregnancy and breastfeeding can drain your stores by 30–40%, often well before symptoms surface.",
  };
  const blurb = lifestageBlurb[ls] || lifestageBlurb.ttc;
  return screenInterstitial({
    label: 'INTERSTITIAL · 4 OF 6',
    stat: 'Nutrient depletion can be <em>silent.</em>',
    body: "It's often subtle — fatigue you've gotten used to, sleep that's been off for years, energy you blame on busy weeks. The absence of symptoms doesn't mean the absence of depletion. And " + blurb,
  });
}

function screenQ2() {
  const stage = clearStage();
  const card = el('div', { class: 'card' });
  card.appendChild(el('div', { class: 'eyebrow' }, 'QUESTION 2 OF 7'));

  const ls = state.answers.lifestage;
  if (ls === 'egg_freezing') {
    card.appendChild(el('h1', {}, 'Where are you in your egg freezing or IVF timeline?'));
    card.appendChild(el('p', { class: 'helper' }, 'Egg quality takes 90–100 days to develop — timing matters.'));
    card.appendChild(singleSelect('stageDetail', [
      { value: 'egg_freezing_6plus',     label: 'Just researching · 6+ months out' },
      { value: 'egg_freezing_3_6',       label: '3–6 months from retrieval' },
      { value: 'egg_freezing_0_3',       label: '0–3 months from retrieval (active prep)' },
      { value: 'egg_freezing_post',      label: 'Already retrieved · planning a transfer' },
    ]));
  } else if (ls === 'ttc') {
    card.appendChild(el('h1', {}, 'How long have you been trying or planning?'));
    card.appendChild(singleSelect('stageDetail', [
      { value: 'ttc_thinking', label: 'Just thinking about it' },
      { value: 'ttc_0_6',      label: '0–6 months in' },
      { value: 'ttc_6_12',     label: '6–12 months in' },
      { value: 'ttc_12plus',   label: '12+ months' },
    ]));
  } else if (ls === 'pregnant') {
    card.appendChild(el('h1', {}, 'What\'s your due date?'));
    card.appendChild(el('p', { class: 'helper' }, 'We\'ll use this to tailor your nutrient priorities by trimester. Estimate is fine.'));
    const wrap = el('div', { class: 'date-wrap' });
    wrap.appendChild(el('label', {}, 'Estimated due date'));
    const minDate = new Date(); minDate.setDate(minDate.getDate() - 30);
    const maxDate = new Date(); maxDate.setDate(maxDate.getDate() + 280);
    const fmt = d => d.toISOString().split('T')[0];
    const input = el('input', {
      type: 'date',
      min: fmt(minDate),
      max: fmt(maxDate),
      value: state.answers.dueDate || '',
    });
    input.addEventListener('change', e => {
      state.answers.dueDate = e.target.value;
      // compute trimester
      const due = new Date(e.target.value);
      const conception = new Date(due.getTime() - 280 * 86400000);
      const today = new Date();
      const weeks = Math.floor((today - conception) / (7 * 86400000));
      let detail = 'pregnant_t1';
      if (weeks >= 28) detail = 'pregnant_t3';
      else if (weeks >= 14) detail = 'pregnant_t2';
      state.answers.stageDetail = detail;
      // Update the info line
      info.textContent = weeks >= 0 && weeks <= 42
        ? `You\'re about ${weeks} weeks along — ${detail === 'pregnant_t3' ? 'third' : detail === 'pregnant_t2' ? 'second' : 'first'} trimester.`
        : 'Please choose a date within the next 9 months.';
      continueBtn.disabled = !(weeks >= 0 && weeks <= 42);
    });
    wrap.appendChild(input);
    const info = el('p', { class: 'date-info' }, 'Pick your estimated due date.');
    wrap.appendChild(info);
    card.appendChild(wrap);

    const continueBtn = el('button', {
      class: 'btn lg',
      onclick: () => go(nextAfter(state.step)),
    }, 'Continue →');
    continueBtn.disabled = !state.answers.dueDate;
    card.appendChild(el('div', { class: 'btn-row' },
      el('button', { class: 'back-link', onclick: back }, '← Back'),
      continueBtn
    ));
  } else if (ls === 'postpartum') {
    card.appendChild(el('h1', {}, 'How far postpartum are you?'));
    card.appendChild(singleSelect('stageDetail', [
      { value: 'postpartum_0_3',   label: '0–3 months' },
      { value: 'postpartum_3_6',   label: '3–6 months' },
      { value: 'postpartum_6_12',  label: '6–12 months' },
      { value: 'postpartum_12plus',label: '12+ months' },
    ]));
  }

  if (ls !== 'pregnant') card.appendChild(backRow());
  stage.appendChild(card);
}

function screenQ3() {
  const stage = clearStage();
  const card = el('div', { class: 'card' });
  card.appendChild(el('div', { class: 'eyebrow' }, 'QUESTION 3 OF 7'));
  card.appendChild(el('h1', {}, 'What prenatal are you currently taking?'));
  card.appendChild(el('p', { class: 'helper' }, 'Be honest — no judgment here.'));
  card.appendChild(singleSelect('currentPrenatal', [
    { value: 'leading_retail',  label: 'A leading retail brand (Ritual, One A Day, Nature Made…)' },
    { value: 'rx',              label: 'A doctor-prescribed prenatal' },
    { value: 'whole_food_gummy',label: 'A whole-food, gummy, or "natural" prenatal' },
    { value: 'none',            label: 'Nothing yet' },
    { value: 'needed',          label: 'I\'m already on Needed' },
  ]));
  card.appendChild(backRow());
  stage.appendChild(card);
}

function screenQ4() {
  const stage = clearStage();
  const card = el('div', { class: 'card' });
  card.appendChild(el('div', { class: 'eyebrow' }, 'QUESTION 4 OF 7'));
  card.appendChild(el('h1', {}, 'Which of these have you noticed lately?'));
  card.appendChild(el('p', { class: 'helper' }, 'Pick all that apply. Each one is a clue.'));
  card.appendChild(multiSelect('symptoms', [
    { value: 'fatigue',   label: 'Persistent fatigue or low energy' },
    { value: 'nausea',    label: 'Nausea (especially in the morning)' },
    { value: 'brain_fog', label: 'Brain fog or trouble focusing' },
    { value: 'mood',      label: 'Mood swings or anxiety spikes' },
    { value: 'sleep',     label: 'Trouble falling or staying asleep' },
    { value: 'hair_skin', label: 'Hair shedding, dry skin, or brittle nails' },
    { value: 'feel_okay', label: 'Honestly, I feel okay' },
  ]));

  const continueBtn = el('button', {
    class: 'btn lg',
    onclick: () => go(nextAfter(state.step)),
  }, 'Continue →');
  continueBtn.disabled = state.answers.symptoms.length === 0;
  card.appendChild(el('div', { class: 'btn-row' },
    el('button', { class: 'back-link', onclick: back }, '← Back'),
    continueBtn
  ));
  stage.appendChild(card);
}

function screenQ5() {
  const stage = clearStage();
  const card = el('div', { class: 'card' });
  card.appendChild(el('div', { class: 'eyebrow' }, 'QUESTION 5 OF 7'));
  card.appendChild(el('h1', {}, 'How often do you eat fatty fish?'));
  card.appendChild(el('p', { class: 'helper' }, 'Salmon, sardines, mackerel — we\'re looking at omega-3 DHA.'));
  card.appendChild(singleSelect('dhaIntake', [
    { value: 'twice_weekly',     label: '2+ times a week' },
    { value: 'about_weekly',     label: 'About once a week' },
    { value: 'few_times_month',  label: 'A few times a month' },
    { value: 'rarely_never',     label: 'Rarely or never' },
    { value: 'avoid_fish',       label: 'I avoid fish (vegetarian, allergy, mercury)' },
  ]));
  card.appendChild(backRow());
  stage.appendChild(card);
}

function screenQ6() {
  const stage = clearStage();
  const card = el('div', { class: 'card' });
  card.appendChild(el('div', { class: 'eyebrow' }, 'QUESTION 6 OF 7'));
  card.appendChild(el('h1', {}, 'Have you had your iron checked recently?'));
  const ironHelper = {
    egg_freezing: 'Iron deficiency affects roughly 1 in 5 women — and the demands of a retrieval cycle push it higher.',
    ttc:          'Iron deficiency affects roughly 1 in 5 women — and pregnancy will nearly double the need.',
    pregnant:     'Iron is the nutrient most pregnancies run short on.',
    postpartum:   'Birth and breastfeeding both deplete iron — postpartum anemia is more common than people realize.',
  }[state.answers.lifestage] || 'Iron deficiency affects roughly 1 in 5 women.';
  card.appendChild(el('p', { class: 'helper' }, ironHelper));
  card.appendChild(singleSelect('ironStatus', [
    { value: 'low_borderline',   label: 'Yes — flagged as low or borderline' },
    { value: 'in_range',         label: 'Yes — they\'re in range' },
    { value: 'untested_at_risk', label: 'No, but I have signs (heavy periods, vegetarian, fatigue)' },
    { value: 'never_tested',     label: 'No, never tested' },
  ], () => {
    // Skip i6 if iron is already in range — no need to explain what they already know
    render();
    setTimeout(() => go(state.answers.ironStatus === 'in_range' ? 'q7' : 'i6'), 280);
  }));
  card.appendChild(backRow());
  stage.appendChild(card);
}

function screenQ7() {
  const stage = clearStage();
  const card = el('div', { class: 'card' });
  card.appendChild(el('div', { class: 'eyebrow' }, 'QUESTION 7 OF 7'));
  card.appendChild(el('h1', {}, 'How do you prefer to take your nutrients?'));
  card.appendChild(el('p', { class: 'helper' }, 'This changes the format inside your Plan — not the formulation.'));
  card.appendChild(singleSelect('formatPreference', [
    { value: 'capsules_fine', label: '3 capsules a day works fine for me' },
    { value: 'powder',        label: 'I\'d rather mix a powder into a smoothie or food' },
    { value: 'pills_hard',    label: 'Pills are hard right now (nausea, aversion)' },
    { value: 'whatever',      label: 'Whatever delivers the most — I trust the science' },
  ]));
  card.appendChild(backRow());
  stage.appendChild(card);
}

function renderPartnerCard(plan) {
  const card = el('div', { class: 'plan-card' });
  if (plan.image) {
    const imgWrap = el('div', { class: 'result-product-img-card partner-img-card' });
    const img = el('img', { src: plan.image, alt: plan.name, loading: 'eager', class: 'result-product-img' });
    img.onerror = () => { imgWrap.style.display = 'none'; };
    imgWrap.appendChild(img);
    card.appendChild(imgWrap);
  }
  const body = el('div', { class: 'plan-body' });
  body.appendChild(el('div', { class: 'plan-tag' }, plan.tag));
  body.appendChild(el('h2', {}, plan.name));
  body.appendChild(el('div', { class: 'price' },
    el('strong', {}, plan.price), ' ', plan.cadence
  ));

  const comp = el('div', { class: 'components' });
  comp.appendChild(el('div', { class: 'components-label' }, 'For Your Partner'));
  const list = el('div', { class: 'component-list' });
  plan.components.forEach(c => list.appendChild(el('span', { class: 'component-pill' }, c)));
  comp.appendChild(list);
  body.appendChild(comp);

  const proofsWrap = el('div', { class: 'proofs' });
  (plan.proofs || []).forEach((p, i) => {
    const pblock = el('div', { class: 'proof' });
    pblock.appendChild(el('div', { class: 'proof-num' }, '0' + (i + 1)));
    const ptext = el('div', { class: 'proof-text' });
    ptext.appendChild(el('strong', {}, p.heading));
    ptext.appendChild(document.createElement('br'));
    ptext.appendChild(document.createTextNode(p.body));
    pblock.appendChild(ptext);
    proofsWrap.appendChild(pblock);
  });
  body.appendChild(proofsWrap);

  // Offer + CTA — same styling as primary recommendation
  const partnerOffer = el('div', { class: 'offer-block' });
  const partnerLabel = el('p', { class: 'offer-label' });
  partnerLabel.innerHTML = '<strong>20% off</strong> your first month — use code <span class="promo-code">HELLONEEDED</span>';
  partnerOffer.appendChild(partnerLabel);
  partnerOffer.appendChild(NeededQuizCart.createButton({ className: 'btn lg full-cta', text: 'Subscribe & Save →', url: plan.url }));
  partnerOffer.appendChild(el('p', { class: 'offer-sub' }, 'Subscribe & save · cancel anytime'));
  body.appendChild(partnerOffer);

  card.appendChild(body);
  return card;
}

function screenResult() {
  const stage = clearStage();
  const plan = recommendedPlan();
  const score = depletionScore();
  const a = state.answers;

  const card = el('div', { class: 'result' });

  if (a.currentPrenatal === 'needed') {
    const banner = el('div', { class: 'loyalty-banner' });
    banner.appendChild(el('div', { class: 'lb-icon' }, '✓'));
    const txt = el('div', { class: 'lb-text' });
    txt.appendChild(el('strong', {}, 'You\'re already making a great choice.'));
    txt.appendChild(document.createTextNode(
      'Congratulations on choosing Needed — you\'re ahead of 95% of women on standard prenatals. Here\'s what to fine-tune from here.'
    ));
    banner.appendChild(txt);
    card.appendChild(banner);
  }

  const scoreCard = el('div', { class: 'score-card' });
  const scoreNumWrap = el('div', { class: 'score-num-wrap' });
  const scorePct = Math.round((score / 14) * 100);
  scoreNumWrap.appendChild(el('div', { class: 'score-num' }, String(scorePct)));
  scoreNumWrap.appendChild(el('div', { class: 'score-max' }, '/ 100'));
  scoreCard.appendChild(scoreNumWrap);
  const scoreMeta = el('div', { class: 'score-meta' });
  scoreMeta.appendChild(el('div', { class: 'score-label' }, 'YOUR NUTRITIONAL PICTURE'));
  const tier = score >= 9 ? 'Significant nutritional gaps to close'
             : score >= 6 ? 'Meaningful nutritional gaps to address'
             : score >= 3 ? 'Some nutritional gaps to address'
             : "Good foundation — let's keep it that way";
  scoreMeta.appendChild(el('div', { class: 'score-tier' }, tier));
  const meterWrap = el('div', { class: 'score-meter' });
  meterWrap.appendChild(el('div', { class: 'score-meter-fill', style: 'width: ' + Math.min(100, (score/14)*100) + '%' }));
  scoreMeta.appendChild(meterWrap);
  scoreCard.appendChild(scoreMeta);
  card.appendChild(scoreCard);

  const lsLabels = { egg_freezing: 'Egg Freezing & IVF', ttc: 'Trying to Conceive',
    pregnant: 'Pregnancy', postpartum: 'Postpartum & Breastfeeding' };
  const lsLabel = lsLabels[a.lifestage] || 'Your Journey';
  card.appendChild(el('div', { class: 'eyebrow result-plan-eyebrow' }, 'Your Personalized Plan for ' + lsLabel));
  card.appendChild(el('h1', { class: 'result-h1' }, plan.name));

  const starsEl = el('div', { class: 'result-stars' });
  starsEl.innerHTML = '4.7★ <span class="result-review-count">· 3,000+ reviews</span>';
  card.appendChild(starsEl);

  const priceEl = el('div', { class: 'result-price-row' });
  priceEl.innerHTML = 'From <strong>' + plan.price + '</strong>/month';
  card.appendChild(priceEl);

  if (plan.image) {
    const imgCard = el('div', { class: 'result-product-img-card' });
    const img = el('img', { src: plan.image, alt: plan.name, loading: 'eager', class: 'result-product-img' });
    img.onerror = () => { imgCard.style.display = 'none'; };
    imgCard.appendChild(img);
    card.appendChild(imgCard);
  }

  const benefits = NeededQuizVariant.getPlanBenefits(plan);
  const benefitsSection = el('div', { class: 'result-benefits' });
  benefitsSection.appendChild(el('div', { class: 'result-benefits-label' }, 'Your Plan Includes'));
  const bList = el('ul', { class: 'result-benefits-list' });
  benefits.forEach(b => {
    const li = el('li', { class: 'result-benefit-item' });
    li.appendChild(el('span', { class: 'benefit-check' }, '✓'));
    li.appendChild(el('span', {}, b));
    bList.appendChild(li);
  });
  benefitsSection.appendChild(bList);
  card.appendChild(benefitsSection);

  card.appendChild(el('div', { class: 'result-why-heading' }, 'Why we recommend this for you'));
  const whyCopy = {
    egg_freezing: "You have a 90-day window where every nutrient counts. This plan is built for the cells you're freezing right now.",
    ttc: "Your nutrient stores at conception become your baby's foundation. This plan is built to optimize them before a positive test.",
    pregnant: "Your body is building a human. This plan delivers 12× more nutrition than leading prenatals at the doses pregnancy actually requires.",
    postpartum: "Pregnancy and breastfeeding can drain your stores by 30–40%. This plan is built for recovery and replenishment.",
  };
  card.appendChild(el('p', { class: 'result-why-copy' }, whyCopy[a.lifestage] || whyCopy.pregnant));

  const valueStats = [
    { num: '12×', label: 'More nutrition than leading prenatals' },
    { num: '22+', label: 'Essential nutrients' },
    { num: '1,000mg', label: 'DHA+EPA per serving' },
    { num: '200mg', label: 'Choline per serving' },
  ];
  const statsGrid = el('div', { class: 'result-stats-grid' });
  valueStats.forEach(s => {
    const item = el('div', { class: 'result-stat-card' });
    item.appendChild(el('div', { class: 'result-stat-num' }, s.num));
    item.appendChild(el('div', { class: 'result-stat-label' }, s.label));
    statsGrid.appendChild(item);
  });
  card.appendChild(statsGrid);

  const offerBlock = el('div', { class: 'offer-block' });
  const offerLabel = el('p', { class: 'offer-label' });
  offerLabel.appendChild(document.createTextNode(''));
  const offerStrong = el('strong', {}, '20% off');
  offerLabel.appendChild(offerStrong);
  offerLabel.appendChild(document.createTextNode(' your first month — use code '));
  const codeSpan = el('span', { class: 'promo-code promo-copy', title: 'Tap to copy' });
  codeSpan.textContent = 'HELLONEEDED';
  codeSpan.addEventListener('click', () => {
    const code = 'HELLONEEDED';
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(() => {
        codeSpan.textContent = '✓ Copied!';
        codeSpan.classList.add('promo-copied');
        setTimeout(() => { codeSpan.textContent = code; codeSpan.classList.remove('promo-copied'); }, 1800);
      });
    } else {
      const ta = document.createElement('textarea');
      ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0';
      QUIZ_ROOT.appendChild(ta); ta.select(); document.execCommand('copy'); QUIZ_ROOT.removeChild(ta);
      codeSpan.textContent = '✓ Copied!';
      codeSpan.classList.add('promo-copied');
      setTimeout(() => { codeSpan.textContent = code; codeSpan.classList.remove('promo-copied'); }, 1800);
    }
  });
  offerLabel.appendChild(codeSpan);
  offerBlock.appendChild(offerLabel);
  offerBlock.appendChild(NeededQuizCart.createButton({ className: 'btn lg full-cta', text: 'Get My Plan — 20% Off →', url: plan.url }));
  offerBlock.appendChild(el('p', { class: 'offer-sub' }, 'Subscribe & save · cancel anytime'));
  card.appendChild(offerBlock);

  const trust = el('ul', { class: 'trust-checklist' });
  [
    '1M+ prenatals sold',
    'Trusted by 500k+ women',
    '15k+ practitioners recommend Needed',
  ].forEach(t => {
    const li = el('li', { class: 'trust-check-item' });
    li.appendChild(el('span', { class: 'trust-check-icon' }, '✓'));
    li.appendChild(el('span', {}, t));
    trust.appendChild(li);
  });
  card.appendChild(trust);

  NeededQuizVariant.appendResultMerchandising(card, plan);

  const partner = partnerPlan();
  if (partner) {
    const bridge = el('div', { class: 'partner-bridge' });
    bridge.appendChild(el('div', { class: 'partner-eyebrow' }, "Don't go it alone"));
    bridge.appendChild(el('h2', {}, 'Sperm health is half the equation.'));
    bridge.appendChild(el('p', {},
      'After 6+ months of trying, this is the time to bring your partner into the conversation. Sperm cells take ~74 days to mature — what he eats today is what shows up at conception 2–3 months from now.'
    ));
    card.appendChild(bridge);
    card.appendChild(renderPartnerCard(partner));
    const bothCta = el('div', { class: 'both-plans-cta' });
    bothCta.innerHTML = 'Both plans subscribe independently. Add each to cart and use code <span class="promo-code">HELLONEEDED</span> for <strong>20% off</strong> both.';
    card.appendChild(bothCta);
  }

  const restartWrap = el('p', { style: 'font-size: 12px; color: var(--grey); margin-top: 32px; text-align: center;' });
  restartWrap.appendChild(el('button', {
    class: 'cta-secondary',
    style: 'display: inline; padding: 0; font-size: 12px; color: var(--grey);',
    onclick: () => {
      state.step = 'intro';
      state.history = [];
      state.answers = {
        lifestage: null, stageDetail: null, dueDate: null, breastfeeding: null,
        currentPrenatal: null, symptoms: [], dhaIntake: null, ironStatus: null,
        formatPreference: null,
      };
      render();
    },
  }, 'Retake the quiz'));
  card.appendChild(restartWrap);

  stage.appendChild(card);
}

// ============================================================
//   ROUTER
// ============================================================
// Some interstitials are static; others are functions that take the user's
// lifestage and return a tailored object so users in TTC / IVF / postpartum
// don't see pregnancy-specific framing.
const interstitials = {
  i1: {
    label: 'INTERSTITIAL · 1 OF 6',
    stat: 'The bar most prenatals clear was set <em>without us in the room.</em>',
    body: [
    'Over 350 clinical studies show minimum nutrient standards (RDAs — Recommended Daily Allowances) for women in fertility, pregnancy & postpartum are outdated',
    '83% of the studies behind those RDAs excluded women entirely',
    'Standard prenatals are formulated to meet those outdated minimums — not your real nutritional needs',
    'Needed delivers optimal doses in forms your body can actually use — not minimums your body can barely process',
  ],
  },

  i2: (ls) => {
    const variants = {
      egg_freezing: {
        stat: 'Egg cells take <em>3–4 months</em> to mature.',
        body: [
          'Egg cell maturation takes 3–4 months',
          'What you load now is what shows up in the eggs you freeze',
          'Folate, choline, DHA, antioxidants, and CoQ10 are all essential during this window',
          "The window you're in right now is when these nutrients have the greatest impact — starting now matters",
        ],
      },
      ttc: {
        stat: 'Egg cells take <em>3–4 months</em> to mature.',
        body: [
          'What you eat today shows up at conception 3+ months from now',
          'Folate, choline, DHA, and antioxidants need to be loaded before a positive test — not after',
          'Diet alone almost never gets you there',
          "Replenishment isn't optional — it's the baseline",
        ],
      },
      pregnant: {
        stat: 'Nutrient demand <em>climbs sharply</em> at every trimester.',
        body: [
          'Blood volume rises by nearly 50% by the third trimester',
          'Iron, B12, and choline needs climb with it — every single trimester',
          "Even the most balanced diet can't keep up with what pregnancy demands",
          "Replenishment isn't optional — it's the baseline",
        ],
      },
      postpartum: {
        stat: 'Pregnancy can drain you <em>by 30–40%.</em>',
        body: [
          'Pregnancy and breastfeeding can drain your nutrient stores by 30–40%',
          'Even months after birth, those debts can still be present',
          'Breastfeeding adds to the ongoing demand',
          "Replenishment isn't a luxury — it's recovery",
        ],
      },
    };
    // Post-retrieval: planning a transfer — focus on implantation prep, not egg quality
    if (ls === 'egg_freezing' && state.answers.stageDetail === 'egg_freezing_post') {
      return {
        label: 'INTERSTITIAL · 2 OF 6',
        stat: "Retrieval is done. Now it's about <em>preparing to carry.</em>",
        body: [
          'The focus now shifts from egg quality to creating the optimal environment for implantation',
          'Folate and choline support healthy cell division from the moment an embryo implants',
          'Vitamin D and magnesium support uterine health and hormonal balance through your transfer cycle',
          'The nutrients you load in the weeks before transfer become the environment your embryo grows into',
        ],
      };
    }
    return { label: 'INTERSTITIAL · 2 OF 6', ...(variants[ls] || variants.ttc) };
  },

  i3: (ls) => {
    const tailByStage = {
      egg_freezing: 'optimize egg quality or fertility outcomes',
      ttc:          'optimize fertility or pre-conception nutrient stores',
      pregnant:     'optimize maternal and fetal outcomes',
      postpartum:   'optimize postpartum recovery or maternal replenishment',
    };
    const tail = tailByStage[ls] || tailByStage.ttc;
    return {
      label: 'THE HEADLINE STAT · 3 OF 6',
      stat: '<em>95%</em> of women on a standard prenatal are still nutritionally depleted.',
      body: [
        `Most prenatals are built to meet bare-minimum nutrient thresholds (RDAs) set decades ago — not to ${tail}`,
        '4× more vitamin D · 20× more B6 · 12× more choline · 31× more B12',
      ],
      comparison: [
        { label: '22 essential nutrients', needed: true, others: false },
        { label: 'Clinically studied dosages', needed: true, others: false },
        { label: 'Methylated folate (L-5-MTHF)', needed: true, others: false },
        { label: 'Choline at 200mg', needed: true, others: false },
        { label: '3rd-party tested for purity', needed: true, others: false },
        { label: 'No synthetic fillers or dyes', needed: true, others: false },
        { label: 'Practitioner-formulated', needed: true, others: false },
      ],
    };
  },

  i4: (ls) => {
    const detail = state.answers.stageDetail || '';
    // Post-retrieval: preparing for transfer — different framing than egg quality
    if (ls === 'egg_freezing' && detail === 'egg_freezing_post') {
      return {
        label: 'INTERSTITIAL · 4 OF 6',
        stat: "Common doesn't mean normal — especially when you're <em>preparing for transfer.</em>",
        body: [
          'Fatigue, brain fog, and mood changes are common signs of nutritional depletion during a transfer cycle',
          'Folate and choline support healthy cell division from the moment of implantation',
          'Magnesium and vitamin D help regulate the hormonal balance your transfer cycle depends on',
          "These symptoms are clues — your body showing you where it needs support before transfer",
        ],
      };
    }
    let key = ls;
    if (ls === 'pregnant') {
      if (detail === 'pregnant_t3') key = 'pregnant_t3';
      else if (detail === 'pregnant_t2') key = 'pregnant_t2';
      else key = 'pregnant_t1';
    }
    const variants = {
      egg_freezing: {
        stat: "Common doesn't mean normal — especially when you're <em>optimizing for egg quality.</em>",
        body: [
          'During egg prep, oxidative stress increases demand for CoQ10, Selenium & Vitamin E',
          'Fatigue can signal iron deficiency — that\'s why Needed offers iron separately from your Multi, so you can add it precisely if your levels call for it',
          'Brain fog and mood changes often trace back to low choline and methylated folate',
          "These symptoms are clues — your body showing you where the gaps are",
        ],
      },
      ttc: {
        stat: "Common doesn't mean normal — especially when you're <em>preparing to conceive.</em>",
        body: [
          'Fatigue, brain fog, and mood changes are the most common early signs of nutritional depletion',
          'Folate, choline, and B12 need to be optimal at conception — not after a positive test',
          'Low iron before pregnancy means entering it already behind',
          "These symptoms are clues — your body showing you where the gaps are",
        ],
      },
      pregnant_t1: {
        stat: "Common doesn't mean normal — especially in the <em>first trimester.</em>",
        body: [
          'First trimester fatigue and nausea often trace back to B6, B12, and choline deficiency',
          'The brain and neural tube are forming now — these nutrients are non-negotiable',
          'Nausea compounds the gap by making it harder to eat well',
          "The right prenatal at clinical doses can make a measurable difference in how you feel",
        ],
      },
      pregnant_t2: {
        stat: "Common doesn't mean normal — especially in the <em>second trimester.</em>",
        body: [
          'Energy crashes and mood changes in T2 often connect to choline, iron, and DHA',
          "Your baby's brain is growing fastest right now — choline and DHA demand is peaking",
          'Hair, skin, and nail changes can signal low zinc, biotin, and selenium',
          "These symptoms are clues — your body showing you where the gaps are",
        ],
      },
      pregnant_t3: {
        stat: "Common doesn't mean normal — especially in the <em>third trimester.</em>",
        body: [
          "Third trimester fatigue is often iron-deficiency anemia — your blood volume has nearly doubled",
          'Sleep issues often trace back to low magnesium and vitamin D',
          'Your baby is pulling nutrients from you — your stores are depleting faster than ever',
          "These symptoms are clues — your body showing you where the gaps are",
        ],
      },
      postpartum: {
        stat: "Common doesn't mean normal — especially in the <em>postpartum window.</em>",
        body: [
          'Postpartum fatigue, mood changes, and brain fog are the most under-addressed signs of depletion',
          'Birth depletes iron rapidly — breastfeeding adds to the ongoing demand',
          "DHA, choline & B12 transfer through breastmilk — if you're low, your baby may be too",
          "These symptoms are clues — your body showing you what pregnancy and birth left behind",
        ],
      },
    };
    const v = variants[key] || variants.ttc;
    return { label: 'INTERSTITIAL · 4 OF 6', ...v };
  },

  i5: (ls) => {
    const variants = {
      egg_freezing: {
        stat: '<em>95%</em> of women fall short of the omega-3 they need.',
        body: [
          'DHA supports egg cell membrane integrity and hormone balance',
          'It also supports early fetal brain development — DHA is the primary structural building block of neural tissue',
          "Most leading prenatals don't include DHA — Needed Omega-3 delivers 500mg DHA per serving, offered separately for precise dosing",
        ],
      },
      ttc: {
        stat: '<em>95%</em> of women fall short of the omega-3 they need.',
        body: [
          'DHA needs to be loaded 90+ days before conception',
          "It builds the foundation of your baby's brain — and supports your hormones right now",
          "Most leading prenatals don't include DHA — Needed Omega-3 delivers 500mg DHA per serving, offered separately for precise dosing",
        ],
      },
      pregnant: {
        stat: '<em>95%</em> of mothers fall short of the omega-3 they need.',
        body: [
          "DHA is the structural building block of your baby's brain",
          'The brain is roughly 60% fat by weight — DHA is the most abundant omega-3 in it',
          "Most leading prenatals don't include DHA — Needed Omega-3 delivers 500mg DHA per serving, offered separately for precise dosing",
        ],
      },
      postpartum: {
        stat: '<em>95%</em> of mothers fall short of the omega-3 they need.',
        body: [
          "Your DHA becomes your baby's DHA through breastmilk",
          'It also supports your mood, brain, and postpartum recovery',
          "Most leading prenatals don't include DHA — Needed Omega-3 delivers 500mg DHA per serving, offered separately for precise dosing",
        ],
      },
    };
    return { label: 'INTERSTITIAL · 5 OF 6', ...(variants[ls] || variants.ttc) };
  },

  i6: (ls) => {
    const variants = {
      egg_freezing: {
        stat: 'Iron deficiency affects <em>1 in 5</em> women.',
        body: [
          'Heavy periods, vegetarian diets, and retrieval cycles all push iron need higher',
          'Iron deficiency can quietly affect egg quality and energy long before a diagnosis',
          'Putting iron in the same pill as your multi reduces absorption of both',
          'Needed offers iron separately — glycinate-bound, only when you actually need it',
        ],
      },
      ttc: {
        stat: 'Iron deficiency affects <em>1 in 5</em> women.',
        body: [
          'Iron deficiency affects 1 in 5 women — heavy periods and vegetarian diets push need higher',
          'Pregnancy will nearly double your iron requirement',
          "Better to enter pregnancy with healthy stores than to chase them after a positive test",
          'Needed offers iron separately — glycinate-bound, for personalized dosing',
        ],
      },
      pregnant: {
        stat: 'Iron requirements <em>nearly double</em> in pregnancy.',
        body: [
          'Up to half of pregnant women develop iron-deficiency anemia',
          'Iron requirements nearly double in pregnancy — standard doses rarely keep up',
          'Putting iron in the same pill as your multi reduces absorption of both',
          'Needed offers iron separately — glycinate-bound, for gentler digestion and personalized dosing',
        ],
      },
      postpartum: {
        stat: 'Iron stores often crash <em>after birth.</em>',
        body: [
          'Birth itself depletes iron — postpartum anemia is more common than most realize',
          'Breastfeeding adds to the ongoing demand',
          'Putting iron in the same pill as your multi reduces absorption of both',
          'Needed offers iron separately — glycinate-bound, for personalized dosing',
        ],
      },
    };
    return { label: 'INTERSTITIAL · 6 OF 6', ...(variants[ls] || variants.ttc) };
  },
};


// ============================================================
//   TIMELINE SCREEN (i7)
// ============================================================
function screenTimeline() {
  const a = state.answers;
  const ls = a.lifestage;
  const detail = a.stageDetail || '';

  const stages = {
    egg_freezing: {
      stage: 'Preconception',
      sub: 'Includes fertilization, implantation, and the very beginning of the neural tube.',
      bullets: [
        'Vitamin A, Selenium, Iodine & Zinc support healthy fertility',
        'Folate, Choline & B12 support early neural development',
        'Magnesium & Vitamin D support restful sleep and nervous system function',
      ],
    },
    ttc: {
      stage: 'Preconception',
      sub: 'Includes fertilization, implantation, and the very beginning of the neural tube.',
      bullets: [
        'Vitamin A, Selenium, Iodine & Zinc support healthy fertility',
        'Folate, Choline & B12 support early neural development',
        'Magnesium & Vitamin D support restful sleep and nervous system function',
      ],
    },
    pregnant_t1: {
      stage: 'First Trimester',
      sub: "Fight fatigue and support your baby's early brain and cognitive development.",
      bullets: [
        'Folate & Choline support brain and cognitive development',
        'Zinc supports normal growth during early organ formation',
        'B vitamins help support energy for your busy life',
      ],
    },
    pregnant_t2: {
      stage: 'Second Trimester',
      sub: 'The support you need for new movement and growing momentum.',
      bullets: [
        'Choline supports healthy brain development',
        'Calcium, Magnesium, Vitamin D & K2 support healthy bone and tooth formation',
        'Vitamin C supports collagen formation for maternal skin and connective tissue',
      ],
    },
    pregnant_t3: {
      stage: 'Third Trimester',
      sub: 'Fuel for the finish line as your blood volume peaks and nutrient transfer to baby is maximal.',
      bullets: [
        'Vitamin B12 supports healthy nervous system development in late pregnancy',
        'Vitamin D & Zinc support healthy immune system function for mom and baby',
        'Nutrient density becomes critical for stamina and recovery from birth',
      ],
    },
    postpartum: {
      stage: 'Postpartum & Beyond',
      sub: 'Nourish yourself by replenishing nutrient stores and supporting your physical recovery.',
      bullets: [
        'Vitamin D, A, C & Zinc support physical recovery from birth',
        'Vitamin A, Iodine, Choline, Selenium, E, C, D, B6 & B12 support breast milk density',
        'Vitamin B12 & B6 support a healthy metabolism and energy to stay active',
      ],
    },
  };

  let key = ls;
  if (ls === 'pregnant') {
    if (detail === 'pregnant_t3') key = 'pregnant_t3';
    else if (detail === 'pregnant_t2') key = 'pregnant_t2';
    else key = 'pregnant_t1';
  }
  const data = stages[key] || stages.ttc;

  const stage = clearStage();
  const card = el('div', { class: 'card' });

  // ── Section 1: Lifestage nutrient focus ──
  card.appendChild(el('div', { class: 'eyebrow' }, data.stage.toUpperCase()));
  card.appendChild(el('h1', {}, data.sub));

  // ── Section 2: Habit building — standalone block ──
  const habitBlock = el('div', { class: 'habit-block' });
  habitBlock.appendChild(el('div', { class: 'habit-heading' }, 'It takes 90 days to build the habit and feel the full results.'));
  habitBlock.appendChild(el('p', { class: 'habit-sub' }, 'But from day one, the support is already happening — at a cellular level, before you feel it.'));
  const timeline = el('div', { class: 'timeline-strip' });
  const milestones = [
    { time: 'Day 1',   label: 'Nutrients begin working at a cellular level' },
    { time: '30 days', label: 'Many notice improvements in energy & mood' },
    { time: '90 days', label: 'Full benefit — stores replenished, habit built' },
  ];
  milestones.forEach(m => {
    const item = el('div', { class: 'timeline-item' });
    item.appendChild(el('div', { class: 'timeline-time' }, m.time));
    item.appendChild(el('div', { class: 'timeline-label' }, m.label));
    timeline.appendChild(item);
  });
  habitBlock.appendChild(timeline);
  card.appendChild(habitBlock);

  const btn = el('button', { class: 'btn lg', onclick: () => go(nextAfter(state.step)) }, 'See my plan →');
  card.appendChild(el('div', { class: 'btn-row' },
    el('button', { class: 'back-link', onclick: back }, '← Back'),
    btn
  ));
  stage.appendChild(card);
}

function recommendedPlan() {
  return NeededQuizVariant.recommendedPlan();
}

function render() {
  updateProgress();
  const s = state.step;
  QUIZ_ROOT.classList.toggle('show-footer', s === 'intro' || s === 'result');
  if (s === 'intro')   return screenIntro();
  if (s === 'q1')      return screenQ1();
  if (s === 'q2')      return screenQ2();
  if (s === 'q3')      return screenQ3();
  if (s === 'q4')      return screenQ4();
  if (s === 'q5')      return screenQ5();
  if (s === 'q6')      return screenQ6();
  if (s === 'q7')      return screenQ7();
  if (s === 'result')  return screenResult();
  if (s === 'i7')     return screenTimeline();
  if (s === 'i3' && state.answers.currentPrenatal === 'none')   return screenWhyPrenatal();
  if (s === 'i3' && state.answers.currentPrenatal === 'needed') return screenAlreadyOnNeeded();
  if (s === 'i4' && state.answers.symptoms.includes('feel_okay')) return screenSilentDepletion();
  if (interstitials[s]) {
    const data = typeof interstitials[s] === 'function'
      ? interstitials[s](state.answers.lifestage)
      : interstitials[s];
    return screenInterstitial(data);
  }
}

window.NeededQuizCore = {
  /** Shared quiz engine APIs for variant scripts (needed-quiz-vlaunch.js / vplans.js). */
  deps() {
    return { state, depletionScore, IMG, el };
  },
  register(variant) {
    Object.assign(NeededQuizVariant, variant);
    render();
  },
};
})();
